module.exports = __webpack_public_path__ + "img/icon_info.575f55a0.svg";